import React, { useEffect, useState } from "react";
import LayoutFrontend from "./inc/layout-frontend";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import PaysService from "../services/PaysService";
import ContactsService from "../services/ContactsService";
import Swal from "sweetalert2";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';


export default function Contact() {

    const [nom, setNom] = useState('');
    const [email, setEmail] = useState('');
    const [telephone, setTelephone] = useState('');
    const [sujet, setSujet] = useState('');
    const [message, setMessage] = useState('');
    const [pays, setPays] = useState([]);
    const [pays_id, setPays_id] = useState('');
    const [telephoneError, setTelephoneError] = useState('');


    useEffect(() => {
        PaysService.index()
            .then(response => {
                if (Array.isArray(response.data.pays)) {
                    setPays(response.data.pays);
                } else {
                    console.error('La réponse ne contient pas un tableau de pays:', response.data);
                }
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des pays:', error);
            });
    }, []);


    const handleChange = (value, country) => {
        setTelephone(value);
        setTelephoneError('');
    };


    const storeContact = async (e) => {
        e.preventDefault();


        const formData = new FormData();
        formData.append('nom', nom);
        formData.append('email', email);
        formData.append('telephone', telephone);
        formData.append('sujet', sujet);
        formData.append('message', message);
        formData.append('pays_id', pays_id)

        // Validation du numéro de téléphone
        if (!/^\+?\d*$/.test(telephone)) {
            setTelephoneError('Le numéro de téléphone n\'est pas valide.');
            return;
        }

        if (telephone === '') {
            setTelephoneError('Veuillez saisir votre téléphone');
            return;
        }

        await ContactsService.store(formData)
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Merci de votre message !',
                    text: response.data.message
                });

                setNom('');
                setEmail('');
                setTelephone('');
                setSujet('');
                setMessage('');
                setPays_id('');

            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: 'Vous avez mal renseigné les champs ou cet élément existe déjà dans la base de données'
                });
                console.log(error);
            });
    };

    return (
        <LayoutFrontend>
           {/** Navbar Start */}
            <div className="container-fluid position-relative p-0">

            <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom: "90px" }}>
                <div className="row py-5">
                    <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                        <h1 className="display-4 text-white animated zoomIn">Contact</h1>
                        <Link className="h5" style={{ color: "goldenrod" }} to={myroutes.homepage}>
                            Accueil
                        </Link>
                        <i className="far fa-circle text-white px-2"></i>
                        <Link className="h5 text-white" to={myroutes.catalogue}>
                            Contact
                        </Link>
                    </div>
                </div>
            </div>

            </div>
            {/** Navbar End */}

            {/** Contact Start */}
            <div className="container-fluid  wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" >
                    <div className="container">
                        <div className="row">
                            <div className="col-md-2">
                            </div>
                            <div className="col-md-8">
                            <h1 className="mb-0" style={{ fontSize: "30px" }}>Pour toutes vos préoccupations, veuillez nous contacter via les panaux suivants :</h1>  
                            </div>
                            <div className="col-md-2">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row g-5 mb-5">
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.1s">
                            <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-phone-alt text-white"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="mb-2">Téléphone</h5>
                                <h4 className="text-primary mb-0">+229 69 61 99 99</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.4s">
                            <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-envelope-open text-white"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="mb-2">Email</h5>
                                <h4 className="text-primary mb-0">sales@dgbook.africa</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.8s">
                            <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-map-marker-alt text-white"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="mb-2">Adresse</h5>
                                <h4 className="text-primary mb-0">Porto-Novo (Bénin)</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row g-5">
                    <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
                        <form onSubmit={storeContact}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <input type="text" className="form-control border-0  px-4" placeholder="Votre nom" style={{ height: "55px", backgroundColor:"#f1f8ff" }} value={nom} onChange={(e) => setNom(e.target.value)} minlength="3" maxlength="100" required autocomplete="nom" autofocus />
                                </div>
                                <div className="col-md-6">
                                    <input type="email" className="form-control border-0  px-4" placeholder="votre email" style={{ height: "55px", backgroundColor:"#f1f8ff" }} value={email} onChange={(e) => setEmail(e.target.value)} minlength="3" maxlength="100" required autocomplete="email" autofocus />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label-wrapper" >
                                        <PhoneInput defaultCountry="bj" value={telephone} onChange={handleChange} inputClass={`form-input ${telephoneError ? 'is-invalid' : ''}`} containerStyle={{ border: '1px solid #ccc', borderRadius: '4px' }} required placeholder="+229 61 00 00 00"
                                            inputStyle={{ width: '80%', border: 'none', outline: 'none', height: "45px" }} />

                                        {telephoneError && (
                                            <span className="invalid-feedback" role="alert">
                                                <strong>{telephoneError}</strong>
                                            </span>
                                        )}
                                    </label>
                                </div>
                                <div className="col-md-6">
                                    <div className="col-md-12 col-sm-12">
                                        <label className="form-control border-0 bg-light px-4">
                                            <select className="form-select" value={pays_id} onChange={(e) => setPays_id(e.target.value)} id="nom_pays" name="nom_pays">
                                                <option value="">Sélectionnez un pays</option>
                                                {pays.map(paysItem => (
                                                    <option key={paysItem.id} value={paysItem.id}>{paysItem.nom_pays}</option>
                                                ))}
                                            </select>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <input type="text" className="form-control border-0  px-4" placeholder="Quel est votre sujet ?" style={{ height: "55px", backgroundColor:"#f1f8ff" }} value={sujet} onChange={(e) => setSujet(e.target.value)} minlength="3" maxlength="100" required autocomplete="sujet" autofocus />
                                </div>
                                <div className="col-12">
                                    <textarea className="form-control border-0  px-4 py-3" rows="4" placeholder="Quel est votre message ?" style={{ backgroundColor:"#f1f8ff" }} value={message} onChange={(e) => setMessage(e.target.value)} minlength="3" maxlength="100" required autocomplete="message" autofocus></textarea>
                                </div>
                                <div className="col-12">
                                    <button className="btn btn-primary w-100 py-3" type="submit">Envoyer un message</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1982.06010685127!2d2.6086438473397977!3d6.506463744172416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b50a2f3540283%3A0xc855970a7d862900!2sMarch%C3%A9%20Ouando%2C%20RNIE1%2C%20Porto-Novo!5e0!3m2!1sfr!2sbj!4v1685469151445!5m2!1sfr!2sbj"
                        width="100%" height="300"  style={{border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
            </div>
            {/** Contact End */}

        </LayoutFrontend>

    )
}